import { URSSAF } from '@/utils/logos'

export const docFrontalierSuisse = {
	url: 'https://www.urssaf.fr/accueil/particulier/travailleur-frontalier-suisse.html',
	title: 'Travailleurs frontaliers en Suisse',
	description:
		"Affiliation, droit d'option et paiement de votre cotisation maladie auprès de l'Urssaf.",
	logo: URSSAF,
}
